module.exports = __webpack_public_path__ + "static/img/food-img-5.059e072.png";


//////////////////
// WEBPACK FOOTER
// ./static/website/images/food-img-5.png
// module id = bTpH
// module chunks = 1